/**
 * ADS Select has a highly complex API surface area with some props not being compatiable with Forge.
 * To simplify usage and ensure compatibility, the following props have been excluded:
 * - backspaceRemovesValue
 * - blurInputOnSelect
 * - captureMenuScroll
 * - components
 * - controlShouldRenderValue
 * - escapeClearsValue
 * - formatGroupLabel
 * - formatOptionLabel
 * - getOptionLabel
 * - getOptionValue
 * - hideSelectedOptions
 * - isOptionDisabled - not working
 * - isOptionSelected - not working
 * - noOptionsMessage - prop excluded because we can’t pass function implementations across the bridge
 * - filterOption - prop excluded because we can’t pass function implementations across the bridge
 *
 */

import React from 'react';
import { SelectWithoutAnalytics as PlatformSelectWithoutAnalytics } from '@atlaskit/select';
import { adaptEventHandler } from '../../utils';
import { PortalConsumer } from '../../../context';

/**
 * Select allows users to make a single selection or multiple selections from a list of options.
 */
export var Select = function Select(props) {
  var _ref = props.forgeDoc.props,
    spacing = _ref.spacing,
    appearance = _ref.appearance,
    testId = _ref.testId,
    autoFocus = _ref.autoFocus,
    defaultValue = _ref.defaultValue,
    closeMenuOnSelect = _ref.closeMenuOnSelect,
    inputValue = _ref.inputValue,
    inputId = _ref.inputId,
    isClearable = _ref.isClearable,
    isLoading = _ref.isLoading,
    isMulti = _ref.isMulti,
    isSearchable = _ref.isSearchable,
    menuIsOpen = _ref.menuIsOpen,
    openMenuOnFocus = _ref.openMenuOnFocus,
    _onInputChange = _ref.onInputChange,
    options = _ref.options,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    isRequired = _ref.isRequired,
    id = _ref.id,
    isDisabled = _ref.isDisabled,
    isInvalid = _ref.isInvalid,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    value = _ref.value,
    name = _ref.name;
  return (
    /*#__PURE__*/
    // Portal is required to render the menu as a sibling of the select container so that it appears ontop of the parent when used within ModalBody
    // ModalBody is a scrollable area and the menu is hidden when rendered within it
    React.createElement(PortalConsumer, null, function (portal) {
      return /*#__PURE__*/React.createElement(PlatformSelectWithoutAnalytics, {
        spacing: spacing,
        appearance: appearance,
        testId: testId,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        closeMenuOnSelect: closeMenuOnSelect,
        inputValue: inputValue,
        inputId: id || inputId,
        isClearable: isClearable,
        isLoading: isLoading,
        isMulti: isMulti,
        isSearchable: isSearchable,
        menuIsOpen: menuIsOpen,
        openMenuOnFocus: openMenuOnFocus,
        menuPortalTarget: portal,
        isRequired: isRequired
        // onInputChange must return a void type for this to work
        ,
        onInputChange: function onInputChange(value, metaData) {
          _onInputChange === null || _onInputChange === void 0 || _onInputChange(value, metaData);
          return;
        },
        options: options,
        placeholder: placeholder,
        onChange: onChange
        // Field props
        ,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        onBlur: adaptEventHandler(onBlur),
        onFocus: adaptEventHandler(onFocus),
        value: value,
        name: name
      });
    })
  );
};